<template>
  <ds-blankslate
    illustration="compatible-profile"
    title="Passo a passo do cadastro do funcionário!">
    <ds-text>
      Para realizar o cadastro, tenha em mãos os dados de contrato e dados pessoais do funcionário.
    </ds-text>
    <ds-row>
      <ds-col>
        <ds-list theme="check">
          <ds-list-item>
            Primeiro, cadastre os <b>dados do contrato</b>, como: data de admissão,
            função, sindicato, jornada de trabalho etc.
            Uma vez cadastrado, os dados serão enviados ao seu contador para conferência.
          </ds-list-item>
          <ds-list-item>
            Depois, cadastre os <b>dados pessoais</b>, como:
            documentos pessoais, endereço, dependentes etc,
            estes dados também serão enviados ao seu contador para conferência final.
          </ds-list-item>
        </ds-list>
      </ds-col>
    </ds-row>
    <template slot="actions">
      <ds-button theme="primary" @click="onNewEmployee">Novo Funcionário</ds-button>
    </template>
  </ds-blankslate>
</template>

<script>
export default {
  name: 'WorkerBlankslatePage',
  data() {
    return {
      showLoading: true,
    };
  },
  methods: {
    onNewEmployee() {
      this.$emit('on-new');
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .ca-list-check-item {
  text-align: justify;
}
</style>
